import { useEffect, useRef } from 'react';
import { useCognito } from '@trading-utils/sso-cognito';
import { TradingSplashScreen } from '@trading-ui/custom';
import { useSessionStorage } from 'usehooks-ts';
import { STORAGE_KEYS } from '@/constants/storageKeys';

export default function SignInView() {
  const { signInWithAzureAD } = useCognito();
  const [, setHasLoggedOut] = useSessionStorage(STORAGE_KEYS.HAS_LOGGED_OUT, false);
  const hasTriggeredAzureLogin = useRef(false);

  useEffect(() => {
    if (hasTriggeredAzureLogin.current) return;

    hasTriggeredAzureLogin.current = true;
    setHasLoggedOut(false);
    signInWithAzureAD('moeveemployee');
  }, [setHasLoggedOut, signInWithAzureAD]);

  /*
  const { authChallenge, forgotPasswordSuccess } = useCognito();

  const [isForgotPassword, setIsForgotPassword] = useState<boolean>(false);
  const [isCreateAccount, setIsCreateAccount] = useState<boolean>(false);

  const renderForm = useCallback(() => {
    if (isForgotPassword && forgotPasswordSuccess) {
      return <ForgotPasswordForm setIsForgotPassword={setIsForgotPassword} />;
    }
    if (authChallenge === 'NEW_PASSWORD_REQUIRED') {
      return <NewPasswordForm />;
    }
    if (isCreateAccount) {
      return <SignUpForm setIsCreateAccount={setIsCreateAccount} />;
    }
    return <SignInForm setIsForgotPassword={setIsForgotPassword} setIsCreateAccount={setIsCreateAccount} />;
  }, [isForgotPassword, forgotPasswordSuccess, authChallenge, isCreateAccount]);

  return (
    <div className={styles.root}>
      <SignInHeader />
      <div className={styles.formContainer}>{renderForm()}</div>
    </div>
  );
  */

  return <TradingSplashScreen open />;
}
